import { Card, Form, Input, Typography } from 'antd'
import { GeckoMeasurementSystem } from 'types'

import { ResolvedMethodAssignment } from './methodAssignments'
import { ScopeEstimateField } from './ScopeEstimateField'
import { scopeBaseUnit, scopeDisplayUnit } from './scopeMeasurement'
import {
  InspectionTechnique,
  MethodAssignment,
  MethodPlanning,
} from './techniqueTypes'

export const MethodAssignmentCard = ({
  method,
  technique,
  config,
  measurementSystem,
  countLabel,
  sourceRequiredArea,
  disabled,
  onChange,
}: {
  method: ResolvedMethodAssignment
  technique: InspectionTechnique | undefined
  config: MethodPlanning
  measurementSystem: GeckoMeasurementSystem
  countLabel: string
  sourceRequiredArea: number | undefined
  disabled: boolean
  onChange: (update: Partial<MethodAssignment>) => void
}) => {
  const scopeType = method.scopeType
  const unit = scopeType
    ? scopeDisplayUnit(scopeType, measurementSystem)
    : undefined
  return (
    <Card size='small' title={method.method}>
      {technique && (
        <Typography.Paragraph type='secondary'>
          {technique.description} POD:{' '}
          {technique.pod === null ? 'Not specified' : `${technique.pod * 100}%`}
          .
        </Typography.Paragraph>
      )}
      {(
        ['procedure', 'instructions'] satisfies Array<
          'procedure' | 'instructions'
        >
      ).map((field) => (
        <Form.Item
          key={field}
          label={
            field === 'procedure'
              ? 'Procedure / specification'
              : 'Location and scanning instructions'
          }
          htmlFor={`${method.id}-${field}`}
          required={config.requiredFields.includes(field)}>
          <Input.TextArea
            id={`${method.id}-${field}`}
            autoSize
            value={method[field]}
            disabled={disabled}
            onChange={(event) => onChange({ [field]: event.target.value })}
          />
        </Form.Item>
      ))}
      {scopeType && unit ? (
        <ScopeEstimateField
          id={method.id}
          scopeType={scopeType}
          unit={unit}
          unitLabel={scopeType === 'count' ? countLabel : unit.name}
          estimate={method.estimatedScope}
          sourceEstimate={
            scopeType === 'area' && sourceRequiredArea !== undefined
              ? { num: sourceRequiredArea, unit: scopeBaseUnit('area').id }
              : undefined
          }
          disabled={disabled}
          required={config.requireEstimate}
          onChange={(estimatedScope) => onChange({ estimatedScope })}
        />
      ) : (
        <Typography.Paragraph type='secondary'>
          Scope units await confirmation in the technique catalogue.
        </Typography.Paragraph>
      )}
    </Card>
  )
}
